import type { Interview, InterviewStatus } from "@/types";

const TYPE_LABELS: Record<string, string> = {
  phone: "Phone",
  video: "Video",
  onsite: "On-Site",
  technical: "Technical",
  behavioral: "Behavioral",
  final: "Final",
};

const STATUS_CLS: Record<InterviewStatus, string> = {
  scheduled: "border-l-blue-500 bg-blue-50 text-blue-900",
  completed: "border-l-emerald-500 bg-emerald-50 text-emerald-900",
  cancelled: "border-l-gray-300 bg-gray-50 text-text-secondary line-through",
  no_show: "border-l-orange-400 bg-orange-50 text-orange-900",
};

function fmtTime(iso: string) {
  return new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

interface Props {
  interview: Interview;
  compact?: boolean;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent) => void;
  onDragStart?: (e: React.DragEvent) => void;
}

export function InterviewCard({ interview, compact, style, onClick, onDragStart }: Props) {
  const cls = STATUS_CLS[interview.status] ?? STATUS_CLS.scheduled;
  return (
    <div
      draggable
      style={style}
      onDragStart={(e) => {
        e.dataTransfer.setData("interview-id", String(interview.id));
        e.dataTransfer.effectAllowed = "move";
        onDragStart?.(e);
      }}
      onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = "move"; }}
      onClick={onClick}
      title={`${interview.candidate_name ?? "Candidate"} — ${TYPE_LABELS[interview.interview_type] ?? interview.interview_type}`}
      className={`cursor-grab overflow-hidden rounded-md border-l-2 px-1.5 py-0.5 text-xs select-none
        transition-shadow hover:shadow-sm active:cursor-grabbing ${cls}`}
    >
      <div className="truncate font-semibold leading-tight">
        {interview.candidate_name ?? "Candidate"}
      </div>
      {!compact && (
        <div className="truncate text-[10px] opacity-70">
          {fmtTime(interview.scheduled_at)} · {TYPE_LABELS[interview.interview_type] ?? interview.interview_type}
        </div>
      )}
    </div>
  );
}
